import { AdminDomain } from './admin-domain.do';
import { SerializableObject } from './serializable-object';
import { User } from './user.do';

/**
 * Dependencies of the admin domain membership
 */
export enum AdminDomainMembershipEagerLoad {
  None = 0,
  User = 1,
  AdminDomain = 2,
  All = 3,
}

export enum AdminDomainRole {
  Administrator = 'Administrator',
}

export class AdminDomainMembership extends SerializableObject {
  public id: string;
  public createdUtc: Date;
  public modifiedUtc: Date;
  public createdBy: string;
  public modifiedBy: string;
  public userId: string;
  public user: User;
  public adminDomainId: string;
  public adminDomain: AdminDomain;
  public role: AdminDomainRole;

  protected coercePropertyType(property: string, value: any): any {
    let returnValue: any = super.coercePropertyType(property, value);

    switch (property) {
      case 'createdUtc':
      case 'modifiedUtc':
        if (typeof value === 'string') {
          return new Date(returnValue);
        }
        return returnValue;

      case 'user':
        return new User(returnValue);

      case 'adminDomain':
        return new AdminDomain(returnValue);

      default:
        return returnValue;
    }
  }
}
